import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class CustomFieldResponseID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
